import React from 'react'
import PropTypes from 'prop-types'
import { StyledModal } from './component.styles'
import Summary from './Summary/component'
import GoalsModal from 'components/GoalsModal'
import ImplementationApproachModal from 'components/ImplementationApproachModal'
import PurposeModal from 'components/PurposeModal'
import ModalHeader from 'components/ModalHeader'
import ModalFooter from 'components/ModalFooter'

const SummaryModal = ({
  currentStep,
  goBack,
  handleClose,
  handleNextButtonClick,
  handleStepChange,
  hasApiError,
  isSubmitting,
  modals,
  preferences,
  siteId,
}) => {
  const currentModal = modals?.[currentStep] || {}
  const { helpCopy, nextLabel, flowLabel } = currentModal

  return (
    !!modals && (
      <StyledModal
        dataTestId="summary-modal"
        isModalOpen={true}
        modalClose={() => handleClose}
      >
        <ModalHeader
          flowLabel={flowLabel}
          handleClose={handleClose}
          handleGoBack={goBack}
          showBackButton={currentStep !== 0}
        />
        {currentStep === 0 && (
          <Summary
            handleStepChange={handleStepChange}
            preferences={preferences}
          />
        )}
        {currentStep === 1 && (
          <ImplementationApproachModal
            handleClose={handleClose}
            siteId={siteId}
          />
        )}
        {currentStep === 2 && (
          <PurposeModal
            handleClose={handleClose}
            hideOutro={true}
            siteId={siteId}
          />
        )}
        {currentStep === 3 && (
          <GoalsModal
            handleClose={handleClose}
            hideOutro={true}
            siteId={siteId}
          />
        )}
        <ModalFooter
          handleNextButtonClick={handleNextButtonClick}
          hasApiError={hasApiError}
          helpCopy={helpCopy}
          isSubmitting={isSubmitting}
          isValid={true}
          modalName="summary"
          nextButtonText={nextLabel}
          showCancelButton={false}
        />
      </StyledModal>
    )
  )
}

SummaryModal.propTypes = {
  additionalGoalCount: PropTypes.number,
  currentStep: PropTypes.number,
  errors: PropTypes.object,
  flowLabel: PropTypes.string,
  goBack: PropTypes.func,
  handleClose: PropTypes.func,
  handleNextButtonClick: PropTypes.func,
  handleStepChange: PropTypes.func,
  hasApiError: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  modals: PropTypes.array,
  preferences: PropTypes.object,
  siteId: PropTypes.string,
}

export default SummaryModal
